module.exports = __webpack_public_path__ + "img/t1.db35f830.jpg";